import type { Breadcrumb, Seo } from '@/types/main'
import { StateGeoAddress } from '@/types/mapServices'

import type {
  Additives,
  AreaProperties,
  LatLng,
  PointFilter,
  PointProperties,
  PolygonProperties,
} from '@/api/modules/delivery/types'
import type { SuggestedOfAddress } from '@/api/modules/geo/geocode.types'

export interface DeliveryDataAddress {
  address: DeliveryAddress
  coordinates: LatLng
  state: StateGeoAddress
  details: PolygonProperties | null
}

export interface DeliveryAddress {
  place: PlacesSearch | null
  address: SuggestedOfAddress | null
}

export enum PlacesSearch {
  AUTOCOMPLETE = 'autocomplete',
  MAP = 'map',
  DEFAULT = 'default',
}

export const enum BalloonType {
  AddressSystem = 'address-system',
  Delivery = 'delivery',
}

export type BalloonTableItem = {
  id: string
  visible: boolean
  label: string
  value: string
}

export interface AttentionFactoid {
  title: string | null
  text: string | null
}

export interface Page {
  seo: Seo
  title: string | null
  attentionFactoid: AttentionFactoid
  noticeText: string | null
  additives: Additives[]
  pointFilters: PointFilter[]
  breadcrumbs: Breadcrumb[]
}

export interface DeliveryState {
  areas: AreaProperties[]
  points: PointProperties[]
  page: Page
  activeTags: string[]
  coordinates: [lat: number, lng: number]
  deliveryAddress: DeliveryDataAddress
  isLoadingAreas: boolean
}

export enum DeliveryInfoType {
  'PAYMENT' = 'PAYMENT',
  'TIME' = 'TIME',
  'ATTENTION' = 'ATTENTION',
}
